import { useEffect } from 'react';
import { useUsageLogger } from '../../context/usageLoggerContext/usageLoggerContext';

export const useTrackFeature = (featureName: string) => {
  const { logFeature } = useUsageLogger();
  useEffect(() => {
    logFeature(featureName);
  }, [featureName, logFeature]);
};
